import _ from "lodash";
import { FormControl, FormHelperText, InputLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";
import InputBox from "./InputBox";
import { PField } from "./NestedField";
import { fieldHasError, requiredValidator } from "./validator";
export default function SelectInput({
    name,
    label,
    options,
    optionsToString,
    initialValue,
    required,
    helperText,
    sx,
    children,
    ...props
}) {
    if (options) {
        children = [];

        for (let index = 0; index < options.length; index++) {
            children.push(
                <ToggleButton key={options[index]} style={{ flex: 1 }} value={options[index]}>
                    {optionsToString ? optionsToString[index] : options[index]}
                </ToggleButton>
            );
        }
    }

    const labelId = _.uniqueId(name);

    return (
        <InputBox sx={sx}>
            <PField name={name} initialValue={initialValue} validate={required ? requiredValidator : null}>
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <FormControl required={required} error={hasError} variant="standard" sx={{ flex: 1, paddingTop: '1.5rem' }} focused>
                            <InputLabel id={labelId}>{label}</InputLabel>
                            <ToggleButtonGroup
                                // color="primary"
                                exclusive
                                {...fieldProps.input} {...props}
                            >
                                {children}
                            </ToggleButtonGroup>

                            <FormHelperText>{hasError ? fieldProps.meta.error : helperText}</FormHelperText>
                        </FormControl>

                    );
                }}
            </PField>
        </InputBox>
    );
}
